import { render, staticRenderFns } from "./FontWeightSelector.vue?vue&type=template&id=ae8b4462&scoped=true"
import script from "./FontWeightSelector.vue?vue&type=script&lang=js"
export * from "./FontWeightSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8b4462",
  null
  
)

export default component.exports